import {
    Button,
    Table,
    TableBody, TableCell, TableHeader,
    TableHeaderCell, TableRow,
    makeStyles
} from "@fluentui/react-components";
import { Master } from "../../library/CosmeWidgetAPIClient";
import { useContext } from "react";
import { CWClientContext } from "../../App";


const useStyles = makeStyles({
    deletedRow: {
        backgroundColor: "#999999",
    },
    regularRow: {

    }
});

type MasterTableProp = {
    masters: Master[];
    setMasters: React.Dispatch<React.SetStateAction<Master[]>>;
}
function MasterTable(prop: MasterTableProp) {
    const styles = useStyles();
    const cwClient = useContext(CWClientContext);
    const masters: Master[] = prop.masters;

    const columns = [
        { columnKey: "cCode", label: "cCode" },
        { columnKey: "cwCode", label: "cwCode" },
        { columnKey: "maker", label: "メーカー名" },
        { columnKey: "brandYomi", label: "ブランド読み" },
        { columnKey: "brand", label: "ブランド名" },
        { columnKey: "item", label: "商品名" },
        { columnKey: "color", label: "色名" },
        { columnKey: "productCategory", label: "商品カテゴリー" },
        { columnKey: "itemCategory", label: "アイテムカテゴリー" },
        { columnKey: "rowAction", label: "アクション" },


    ];


    return (
        <>
            <Table>
                <TableHeader>
                    <TableRow>
                        {columns.map((column) => (
                            <TableHeaderCell key={column.columnKey}>
                                {column.label}
                            </TableHeaderCell>
                        ))}
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {masters.map((item, index, _masters) => (
                        <TableRow key={item.id} className={item.deleted ? styles.deletedRow : styles.regularRow}>
                            <TableCell>{item.cCode}</TableCell>
                            <TableCell>{item.id}</TableCell>
                            <TableCell>{item.maker}</TableCell>
                            <TableCell>{item.brandYomi}</TableCell>
                            <TableCell>{item.brand}</TableCell>
                            <TableCell>{item.item}</TableCell>
                            <TableCell>{item.color}</TableCell>
                            <TableCell>{item.productCategory}</TableCell>
                            <TableCell>{item.itemCategory}</TableCell>
                            <TableCell>
                                <Button
                                    onClick={() => {
                                        cwClient.deleteMaster(item.id).then((result) => {
                                            if (result !== undefined && result !== null) {
                                                _masters[index] = result;
                                                prop.setMasters(_masters);
                                            }
                                        });
                                    }}
                                    disabled={item.cCode !== "::cCode" || item.deleted === true}
                                >削除</Button>
                            </TableCell>
                        </TableRow>

                    ))}
                </TableBody>
            </Table >
        </>

    );
}

export default MasterTable;